import React, { useRef, useState, useEffect } from "react";
import Modal from "react-bootstrap/Modal";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";

function ContactUs({ showContact, setShowContact }) {
  const formRef = useRef(null);
  const [validated, setValidated] = useState(false);
  const [details, setDetails] = useState({
    name: "",
    email: "",
    phone: "",
    message: "",
  });

  const handleSubmit = (event) => {
    const form = formRef.current;
    if (form.checkValidity() === false) {
      event.preventDefault();
      event.stopPropagation();
    }
    setValidated(true);
  };

  const [isExiting, setIsExiting] = useState(false);

  const handleClose = () => {
    setIsExiting(true);
    setTimeout(() => {
      setShowContact(false);
      setIsExiting(false);
    }, 200);
  };

  const handleChangePhone = (e) => {
    console.log(e);
    setDetails({ ...details, phone: e });
  };

  return (
    <Modal
      show={showContact}
      onHide={handleClose}
      centered
      dialogClassName={isExiting ? "aaa custom-modal-exit" : "aaa custom-modal"}
    >
      <Modal.Body>
        <div className="font-cardo contact-us-heading">Let's Get In Touch</div>
        <div className="font-inter text-start contactUs-subHead">
          Or just reach out manually to <span>enquiry@aeonsoftware</span>
        </div>
        <div className="mt-4 contact-us-form">
          <form
            ref={formRef}
            className={`row g-3 needs-validation ${
              validated ? "was-validated" : ""
            }`}
            novalidate
            onSubmit={handleSubmit}
          >
            <div class="col-md-12">
              <label for="validationCustom01" class="form-label">
                <svg
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M12 12C14.7614 12 17 9.76142 17 7C17 4.23858 14.7614 2 12 2C9.23858 2 7 4.23858 7 7C7 9.76142 9.23858 12 12 12Z"
                    stroke="#4E465E"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M20.5901 22C20.5901 18.13 16.7401 15 12.0001 15C7.26016 15 3.41016 18.13 3.41016 22"
                    stroke="#4E465E"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
                Name*
              </label>
              <input
                type="text"
                class="form-control"
                id="validationCustom01"
                placeholder="Enter your full name"
                required
              />
              <div class="valid-feedback">Looks good!</div>
            </div>
            <div class="col-md-12">
              <label for="validationCustom02" class="form-label">
                <svg
                  viewBox="0 0 24 20"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M23.938 3.26291C23.8298 2.71795 23.5882 2.21924 23.2507 1.80726C23.1796 1.71749 23.1052 1.6371 23.0247 1.55671C22.4268 0.955867 21.5876 0.581055 20.6709 0.581055H3.32911C2.41238 0.581055 1.57622 0.955867 0.975516 1.55671C0.895125 1.6371 0.820781 1.71749 0.749438 1.80726C0.411797 2.2192 0.170156 2.71795 0.0649687 3.26291C0.02175 3.47324 0 3.6906 0 3.91035V16.09C0 16.5573 0.0990937 17.0064 0.275813 17.412C0.439734 17.7992 0.681422 18.1496 0.975469 18.4433C1.05 18.5177 1.12402 18.586 1.20478 18.654C1.78069 19.1309 2.52408 19.419 3.32911 19.419H20.6709C21.4762 19.419 22.2228 19.1309 22.7954 18.651C22.8759 18.586 22.9503 18.5177 23.0247 18.4433C23.3186 18.1496 23.5602 17.7992 23.7275 17.412V17.409C23.9042 17.0034 24 16.5573 24 16.0901V3.91035C24 3.6906 23.9786 3.47324 23.938 3.26291ZM2.18011 2.76116C2.47753 2.46407 2.87695 2.28421 3.32911 2.28421H20.6709C21.123 2.28421 21.526 2.46407 21.8199 2.76116C21.8725 2.81409 21.922 2.87305 21.9658 2.93165L12.8764 10.8533C12.6257 11.073 12.316 11.1815 12 11.1815C11.6872 11.1815 11.3777 11.073 11.1237 10.8533L2.03775 2.92827C2.07797 2.86968 2.12752 2.81409 2.18011 2.76116ZM1.70316 16.09V4.69073L8.28084 10.4289L1.70648 16.161C1.70316 16.1393 1.70316 16.1148 1.70316 16.09ZM20.6709 17.7155H3.32911C3.03469 17.7155 2.7592 17.6381 2.52408 17.5021L9.46055 11.4572L10.1081 12.0205C10.65 12.4914 11.3282 12.7299 12 12.7299C12.6753 12.7299 13.3534 12.4914 13.8953 12.0205L14.5425 11.4572L21.4762 17.5021C21.2408 17.6381 20.9653 17.7155 20.6709 17.7155ZM22.2968 16.09C22.2968 16.1148 22.2968 16.1393 22.2937 16.161L15.7193 10.4323L22.2968 4.69377V16.09Z"
                    fill="#4E465E"
                  />
                </svg>
                Email*
              </label>
              <input
                type="email"
                class="form-control"
                id="validationCustom02"
                placeholder="Enter your Email"
                required
              />
              <div class="valid-feedback">Looks good!</div>
            </div>
            <div class="col-md-12">
              <label for="validationCustom03" class="form-label">
                <svg
                  viewBox="0 0 16 21"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M13.9993 15.322L11.3985 13.5774C11.2887 13.4992 11.1601 13.4517 11.0259 13.4397C10.8917 13.4277 10.7567 13.4517 10.6348 13.5092L9.63624 14.0157C9.51097 14.0773 9.37044 14.1009 9.2319 14.0838C9.09336 14.0667 8.96283 14.0095 8.85632 13.9193C6.98944 12.3745 5.7399 10.2102 5.33548 7.82104C5.3106 7.68368 5.32635 7.54205 5.3808 7.41351C5.43524 7.28497 5.52602 7.17512 5.64199 7.09742L6.55116 6.43616C6.66386 6.36193 6.75471 6.25897 6.81434 6.1379C6.87396 6.01684 6.9002 5.88206 6.89034 5.74747L6.67998 2.62277L6.63194 1.8224C6.62326 1.70721 6.58868 1.59547 6.53078 1.49552C6.43792 1.33329 6.28781 1.21161 6.10988 1.15434C5.61922 0.991023 5.09668 0.947149 4.58566 1.02636C4.07464 1.10557 3.5899 1.30558 3.17171 1.60977L2.96748 1.76521L2.86169 1.84631C2.81245 1.88183 2.76516 1.91999 2.72003 1.96062L2.58971 2.08589C0.869573 3.76702 1.19315 7.99347 3.40976 12.1903L4.08414 13.3583C6.60711 17.3707 10.1055 19.7642 12.4319 19.1503L12.6055 19.1001C12.6629 19.0815 12.7193 19.0598 12.7744 19.0351L12.8981 18.985L13.1348 18.8859C13.6071 18.6756 14.0224 18.3556 14.3463 17.9526C14.6701 17.5496 14.8931 17.0752 14.9968 16.5687C15.0362 16.3859 15.0059 16.1951 14.9118 16.0336C14.8542 15.9334 14.7747 15.8476 14.6793 15.7825L13.9993 15.322Z"
                    stroke="#4E465E"
                    stroke-width="1.8"
                    stroke-miterlimit="10"
                  />
                </svg>
                Phone Number*
              </label>
              {/* <input
                type="text"
                class="form-control"
                id="validationCustom03"
                placeholder="Enter you phone number"
                required
              /> */}
              <PhoneInput
                country={"in"}
                value={details.phone}
                onChange={handleChangePhone}
                inputProps={{
                  name: "phone",
                  required: true,
                  autoFocus: true,
                }}
                placeholder="Enter you phone number"
              />
              <div class="invalid-feedback">Please provide a valid city.</div>
            </div>
            <div class="col-md-12">
              <label for="validationCustom03" class="form-label">
                <svg
                  viewBox="0 0 22 20"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M1.25 4.79992C1.25 3.58647 1.25 2.97975 1.48616 2.51627C1.69387 2.10858 2.02533 1.77713 2.43302 1.56941C2.89649 1.33325 3.50322 1.33325 4.71667 1.33325H17.2833C18.4968 1.33325 19.1036 1.33325 19.567 1.56941C19.9747 1.77713 20.3062 2.10858 20.5138 2.51627C20.75 2.97975 20.75 3.58648 20.75 4.79992V18.6666L17.1487 16.8659C16.8757 16.7294 16.7392 16.6611 16.5961 16.613C16.4691 16.5703 16.3383 16.5395 16.2056 16.5208C16.0561 16.4999 15.9035 16.4999 15.5983 16.4999H4.71667C3.50321 16.4999 2.89649 16.4999 2.43302 16.2638C2.02533 16.0561 1.69387 15.7246 1.48616 15.3169C1.25 14.8535 1.25 14.2467 1.25 13.0333V4.79992Z"
                    stroke="#4E465E"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
                Message
              </label>
              <textarea
                class="form-control"
                id="validationCustom03"
                placeholder="Type here..."
                rows={4}
              />
            </div>
            <div class="col-12">
              <button class="contact-us-submit-btn" type="submit">
                Submit
              </button>
            </div>
          </form>
        </div>
      </Modal.Body>
    </Modal>
  );
}

export default ContactUs;
